import React from 'react';
import { connect } from 'react-redux';

import { compose, isProdEnv } from 'shared/helpers';

import { mixClasses as cx, } from 'helpers';



function mapStateToProps(state) {
  return {
    debugState: state.debug,
  };
}


/*
 * DebugMonitor
 */
class DebugMonitor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      // TODO: Expose caught exceptions here if in DEV
      isOpen: false,
    };
  }

  render() {
    const {
      style = {},
      debugState,
    } = this.props;

    // Don't expose any debug info in prod.
    if (process.env.NODE_ENV === 'production') {
      return <div style={style} />;
    }

    const errors = debugState.get('errors');
    const isAlert = errors.size > 0 && !isProdEnv;

    return (
      <div
        className={cx(
          {'bg-red': isAlert},
        )}
        style={style}
      >
      </div>
    );
  }
}


export default compose(
  connect(mapStateToProps),
)(DebugMonitor);



// WEBPACK FOOTER //
// ./src/components/misc/DebugMonitor.js